<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
//eslint-disable-next-line
import Suppliers from "../../../components/suppliers/suppliers.vue";
/**
 * Starter component
 */
export default {
    page: {
        title: "Suppliers",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, Suppliers },
    data() {
        return {
            title: "Suppliers",
            items: [
                // {
                //     text: "Collection List",
                //     href: "/",
                // },
                // {
                //     text: "Suppliers",
                //     active: true,
                // },
            ],
        };
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <Suppliers />
    </Layout>
</template>
